import { render, staticRenderFns } from "./Aside.vue?vue&type=template&id=01945c1d&scoped=true"
import script from "./Aside.vue?vue&type=script&lang=js"
export * from "./Aside.vue?vue&type=script&lang=js"
import style0 from "./Aside.vue?vue&type=style&index=0&id=01945c1d&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"
import style1 from "./Aside.vue?vue&type=style&index=1&id=01945c1d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01945c1d",
  null
  
)

export default component.exports